<template>
  <div class="_wrapper" :class="{ 'is-shop': displayMode === 'shop' }">
    <div id="category" class="flex-full" v-if="displayMode === 'food'">
      <header class=" pt20 pb10 pl20">
        <div class="container">
          <breadcrumbs class="pb20" :with-homepage="true" :routes="breadcrumbs.routes" :active-route="category.name" />
        </div>
      </header>
      <div class="bg-cl-secondary">
        <div class="container pb60">
          <div class="row m0 pt15">
            <h1 v-if="currentPartner.display_mode === 'food'"
                class="h2 col-xs-12 mb20 mt10 align-center light view-more-categ"
            > {{ category.name }} </h1>
            <p v-if="category.description" class="col-xs-12 mb20 align-center category-description">
              {{ category.description }}
            </p>
            <div class="col-md-12 px10 border-box products-list">
              <div v-if="isCategoryEmpty" class="hidden-xs">
                <h4 data-testid="noProductsInfo"> {{ $t('No products found!') }} </h4>
                <p> {{ $t('Please change Your search criteria and try again. If still not finding anything relevant, please visit the Home page and try out some of our bestsellers!') }} </p>
              </div>
              <product-listing :columns="defaultColumn" :products="products" :category_id="category.entity_id"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block mt20" v-else-if="displayMode === 'shop'">
      <breadcrumbs v-if="category"
                   :routes="breadcrumbs.routes"
                   :active-route="category.name"
      />
      <p v-if="category.description" class="category-description">
        {{ category.description }}
      </p>
      <shop-category-grid v-if="categoryId && categoryId !== 0"
                          :current-id="categoryId"
                          :category-name="categoryName"
                          :naming="category.name"
                          :counter="category.children_count"
      />
      <shop-category-swipers v-if="categoryId && categoryId !== 0"
                             :current-id="categoryId"
                             :category-name="categoryName"
      />
      <shop-products-grid :columns="defaultColumn"
                          :products="products"
                          :naming="category.name"
                          :counter="category.product_count"
      />
    </div>
  </div>
</template>

<script>
import Category from '@vue-storefront/core/pages/Category'
import Sidebar from 'theme/components/core/blocks/Category/Sidebar.vue'
import ProductListing from 'theme/components/core/ProductListing.vue'
import Breadcrumbs from 'theme/components/core/Breadcrumbs.vue'
import SortBy from 'theme/components/core/SortBy.vue'
import Columns from 'theme/components/core/Columns.vue'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import CategoryFilter from 'theme/components/core/blocks/Category/CategoryFilter'
import CategorySliders from 'theme/components/theme/blocks/Home/CategorySliders'
import ShopCategoryGrid from 'theme/components/core/blocks/Shop/Product/CategoryGrid'
import ShopCategorySwipers from 'theme/components/core/blocks/Shop/Product/CategorySwipers'
import ShopProductsGrid from 'theme/components/core/blocks/Shop/Product/ProductsGrid'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [Category],
  components: {
    ButtonFull,
    ProductListing,
    Breadcrumbs,
    Sidebar,
    SortBy,
    Columns,
    CategoryFilter,
    CategorySliders,
    ShopCategoryGrid,
    ShopCategorySwipers,
    ShopProductsGrid
  },
  data () {
    return {
      mobileFilters: false,
      defaultColumn: 4
    }
  },
  async asyncData ({ store, route }) {
    await store.dispatch('category/mergeSearchOptions', {
      sort: store.state.config.products.defaultSortBy.attribute + (store.state.config.products.defaultSortBy.order ? ':' + store.state.config.products.defaultSortBy.order : '')
    })
  },
  watch: {
    '$route.path' () {
      this.searchText = ''
    }
  },
  computed: {
    ...mapGetters({
      currentPartnerCode: 'partners/getCurrentPartnerCode',
      currentPartner: 'partners/getCurrentPartner',
      displayMode: 'partners/getCurrentPartnerDisplayMode',
    })
  },
  methods: {
    ...mapActions({
      cleanupSliderProducts: 'products_categories/cleanupSliderProducts',
      cleanUpCategory: 'category/cleanUpCategory'
    }),
    openFilters () {
      this.mobileFilters = true
    },
    closeFilters () {
      this.mobileFilters = false
    },
    notify () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t('Please select the field which You like to sort by'),
        action1: { label: this.$t('OK') }
      })
    },
    columnChange (column) {
      this.defaultColumn = column
    }
  },
  beforeDestroy () {
    this.cleanupSliderProducts()
    this.cleanUpCategory()
  }
}
</script>

<style lang="scss" scoped>
._wrapper {
  width: 100%;

  &.is-shop {
    width: 850px;

    @media only screen and (max-width: 1200px) {
      width: 654px;
    }

    @media only screen and (max-width: 991px) {
      width: 722px;
    }

    @media only screen and (max-width: 768px) {
      width: 530px;
    }

    @media only screen and (max-width: 576px) {
      width: calc(100% - 30px);
      padding: 0 15px;
    }
  }
}

.block {
  width: 850px;

  @media only screen and (max-width: 1200px) {
    width: 654px;
  }

  @media only screen and (max-width: 991px) {
    width: 722px;
  }

  @media only screen and (max-width: 768px) {
    width: 530px;
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
  }
}
.btn {
  &__filter {
    min-width: 100px;
  }
}
.divider {
  width: calc(100vw - 8px);
  bottom: 20px;
  left: -36px;
}
.category-filters {
  width: 242px;
  display: none;
  @media (max-width: 770px) {
    display: block;
  }
}

.mobile-filters {
  display: none;
  overflow: auto;
}

.mobile-filters-button {
  display: none;
}

.mobile-sorting {
  display: none;
}

.category-title {
  line-height: 65px;
}

.sorting {
  label {
    margin-right: 10px;
  }
}

.mobile-category-filter {
  display: none;
}

@media (max-width: 770px) {
  .category-title {
    margin: 0;
    font-size: 36px;
    line-height: 40px;
  }

  .products-list {
    max-width: 100%;
    flex-basis: 100%;
  }

  .mobile-filters {
    display: block;
  }

  .mobile-filters-button {
    display: block;
    height: 45px;
  }

  .sorting {
    display: none;
  }

  .mobile-sorting {
    display: block;
  }

  .category-filters {
    display: none;
  }

  .product-listing {
    justify-content: center;;
  }

  .mobile-filters {
    position: fixed;
    background-color: #F2F2F2;
    z-index: 5;
    padding: 0 40px;
    left: 0;
    width: 100vw;
    height: 100%;
    top: 0;
    box-sizing: border-box;
    border-bottom:2px solid #000
  }

  .mobile-filters-body {
    padding-top: 50px;
  }

  .mobile-category-filter {
    display: block;
  }
}

.close-container {
  left: 0;
}

.close {
  margin-left: auto;
}
.product{
  position: relative;
}
.view-more-categ{
  text-transform: uppercase;
  line-height: normal;
  font-family: 'TTNorms Light', sans-serif;
}
.category-description {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}
</style>
<style lang="scss">
.product{
  position: relative;
}
.product-image {
  max-height: unset !important;
}
</style>
